// Opera 8.0+
var isOpera =
  (!!window.opr && !!opr.addons) ||
  !!window.opera ||
  navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
var isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
var isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function(p) {
    return p.toString() === '[object SafariRemoteNotification]';
  })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

// Internet Explorer 6-11
var isIE = /*@cc_on!@*/ false || !!document.documentMode;

// Edge 20+
var isEdge = !isIE && !!window.StyleMedia;

// Chrome 1 - 79
var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// Edge (based on chromium) detection
var isEdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') != -1;

// Blink engine detection
var isBlink = (isChrome || isOpera) && !!window.CSS;

module.exports = {
  isFirefox: isFirefox,
  isChrome: isChrome,
  isSafari: isSafari,
  isOpera: isOpera,
  isIE: isIE,
  isEdge: isEdge,
  isEdgeChromium: isEdgeChromium,
  isBlink: isBlink,
  name: (
    (isFirefox && 'Firefox') ||
    (isChrome && 'Chrome') ||
    (isSafari && 'Safari') ||
    (isOpera && 'Opera') ||
    (isIE && 'IE') ||
    (isEdge && 'Edge') ||
    (isEdgeChromium && 'EdgeChromium') ||
    (isBlink && 'Blink') ||
    'unknown'
  ),
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/browser.js
 ** module id = 392
 ** module chunks = 0
 **/